export default class ThirdThingProperty {
    identifier?: string = undefined
    converter?: string = undefined
}
